  import { MapComponent } from './component/map/map.component';
  import { TableComponent } from './component/table/table.component';
  import {ContactUsComponent} from './component/contactus/contactus.component'
  import { MainComponent } from './component/main/main.component';
  import { NgModule }  from '@angular/core';
  import { RouterModule, Routes } from '@angular/router';
  import { PlaceComponent } from './component/Place/place.component';
  import {ServiceComponent } from './component/Service/service.component';
  import { AboutComponent } from './component/About/about.component';
  import { StepsComponent } from './component/Steps/steps.component';

  const routes: Routes = [
    { path: '', redirectTo: '/Home', pathMatch: 'full' },
    { path: 'ContactUs',  component: ContactUsComponent , data: { page: 'ContactUs' }},
    { path: 'Home', component: MainComponent , data: { page: 'Home' }},
    { path:'Place/:id', component:PlaceComponent, data: { page: 'Place' }},
    { path:'Place', component:PlaceComponent, data: { state: 'Place' }},
    { path: 'About', component: AboutComponent , data: { page: 'About' }},
    { path: 'Steps', component: StepsComponent , data: { page: 'Steps' }},
  ];

  @NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
  })
  export class AppRoutingModule {}

  


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts